import React from "react";
import { useHistory } from "react-router-dom";
import { isExternalLink } from "../../helpers/helpers.js";

const RedirectBtn = ({ label, url, handleToggleClose }) => {
  const history = useHistory();

  const handleNavigation = () => {
    const isExternal = isExternalLink(url);

    if (isExternal) {
      window.open(url, "_blank", "noopener noreferrer");
    } else {
      history.push(url); // For internal navigation
    }
    handleToggleClose();
  };

  return <button onClick={handleNavigation}>{label}</button>;
};

export default RedirectBtn;
